module.exports = __webpack_public_path__ + "img/logo-menu-branco.f796c49a.png";